import api from './api';

export const cloudinaryService = {
  /**
   * Récupérer la signature d'upload depuis le backend
   * @returns {Promise<{ timestamp, signature, cloudName, apiKey }>}
   */
  getSignature: async () => {
    const response = await api.get('/cloudinary/signature');
    return response.data;
  },

  /**
   * Upload une image directement vers Cloudinary (sans passer par le serveur)
   * @param {File} file - Fichier image à uploader
   * @returns {Promise<{ url: string, publicId: string }>}
   */
  uploadImage: async (file) => {
    const { timestamp, signature, cloudName, apiKey } = await cloudinaryService.getSignature();

    const formData = new FormData();
    formData.append('file', file);
    formData.append('timestamp', timestamp);
    formData.append('signature', signature);
    formData.append('api_key', apiKey);
    formData.append('folder', 'pam-immo');

    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
      { method: 'POST', body: formData }
    );

    if (!response.ok) {
      throw new Error('Erreur lors de l\'upload vers Cloudinary');
    }

    const data = await response.json();
    return {
      url: data.secure_url,
      publicId: data.public_id,
    };
  },
};

export default cloudinaryService;
